import { render, staticRenderFns } from "./WorkstationScreenEditor.vue?vue&type=template&id=2654663b"
import script from "./WorkstationScreenEditor.vue?vue&type=script&lang=js"
export * from "./WorkstationScreenEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports